import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import SimpleBar from 'simplebar-react';
import Typography from '@mui/material/Typography';

import RecordItem from './RecordItem';
import { getField, formatNumber } from 'src/common/helper';
import { fontPrice } from './RecordItem';


type RecordProps = {
  items: any[];
  surgery: any;
  isLoading?: boolean;
  onChange: (index: number, fieldName: string, value: number | null) => void;
};

const Record: React.FC<RecordProps> = (props) => {

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: 'none',
        '& *': { color: 'primary.dark', fontSize: '12px' },
        maxHeight: '100%',
        maxWidth: '100%',
        '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
          backgroundColor: '#CCD1D9',
        },
        overflow: 'hidden'
      }}
    >
      <SimpleBar
        style={{ height: 'calc(100vh - 270px)', borderWidth: '18px' }}
      >
        <Table
          stickyHeader
          sx={{
            '& .MuiTableCell-root.MuiTableCell-head': {
              borderBottom: '3px solid #F3F3F3',
              fontWeight: 700,
              fontSize: '14px',
              height: '36px',
              p: '0px 16px'
            }
          }}
          aria-label='simple table'>
          <TableHead >
            <TableRow >
              <TableCell align={'left'} width={'20%'} sx={{ bgcolor: 'primary.light' }}></TableCell>
              <TableCell align={'left'} width={'40%'} sx={{ bgcolor: 'primary.light' }}>通常価格</TableCell>
              <TableCell align={'left'} width={'40%'} sx={{ bgcolor: 'primary.light' }}>モニター価格</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!props.isLoading ? (
              props.items.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={11}
                    sx={{ textAlign: 'center', verticalAlign: 'center' }}
                  >
                    データがありません
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  <TableRow
                    sx={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      '& .MuiTableCell-root.MuiTableCell-body': {
                        py: '8px',
                        borderBottom: '1px solid #F3F3F3',
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '14.4px'
                      },
                      height: '48px',
                    }}
                  >
                    <TableCell component='td' scope='row' align={'left'}>
                      <Typography
                        sx={{
                          whiteSpace: 'pre-wrap',
                          fontSize: '14px',
                          fontWeight: 400,
                          lineHeight: '14.4px'
                        }}>
                        標準価格
                      </Typography>
                    </TableCell>

                    <TableCell component='td' scope='row' align={'left'}>
                      <Stack direction={'row'} spacing={'10px'} alignItems={'center'}>
                        <Typography
                          component={'label'}
                          sx={{
                            ...fontPrice
                          }}>
                          {formatNumber(getField(props.surgery, 'price_mornitor', 0)) + '円'}
                        </Typography>
                      </Stack>
                    </TableCell>

                    <TableCell component='td' scope='row' align={'left'}>
                      <Stack direction={'row'} spacing={'10px'} alignItems={'center'}>
                        <Typography
                          component={'label'}
                          sx={{
                            ...fontPrice
                          }}>
                          {formatNumber(getField(props.surgery, 'price_mornitor', 0)) + '円'}
                        </Typography>
                      </Stack>
                    </TableCell>
                  </TableRow >

                  {props.items.map((item, index) => (
                    <RecordItem
                      key={index}
                      item={item}
                      index={index}
                      surgery={props.surgery}
                      onChange={props.onChange}
                    />
                  ))}
                </>
              )
            ) : (
              <TableRow>
                <TableCell colSpan={3}>
                  <Stack spacing={1}>
                    <Skeleton variant='rounded' width={'100%'} height={40} />
                    <Skeleton variant='rounded' width={'100%'} height={40} />
                    <Skeleton variant='rounded' width={'100%'} height={40} />
                  </Stack>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </SimpleBar>
    </TableContainer>
  );
};

export default Record;
